import { useTranslation } from 'react-i18next'
import { Switch } from '@/components/ui/switch'
import type { SetupFieldsProps } from '@/modules/types'
import type { UpvotesSpaceConfig } from './upvoteUtils'

/**
 * The only board-specific question of "Create space": prior approval. A board
 * is always one board (no "one or many"); visibility and who can post are the
 * common fields.
 */
export const UpvotesSpaceFields = ({ config, onChange, disabled }: SetupFieldsProps) => {
  const { t } = useTranslation('upvotes')
  const requireApproval = Boolean((config as UpvotesSpaceConfig | undefined)?.requireApproval)
  return (
    <div className="flex items-start justify-between gap-4 rounded-lg border border-gray-200 p-3" data-testid="upvotes-space-fields">
      <div className="min-w-0">
        <p className="text-sm font-medium text-gray-700">{t('config.requireApproval.label')}</p>
        <p className="text-xs text-gray-500">{t('config.requireApproval.hint')}</p>
      </div>
      <Switch checked={requireApproval} disabled={disabled} className="data-[state=checked]:bg-primary" aria-label={t('config.requireApproval.label')}
        onCheckedChange={(checked) => onChange({ ...config, requireApproval: checked })} />
    </div>
  )
}
